import React from 'react';
import styles from './Spinner.module.css';

export default function Spinner({ label = 'Loading…', hint, progress }) {
  const hasProgress = typeof progress === 'number' && progress >= 0;

  return (
    <div className={styles.wrapper}>
      <div className={styles.ring} />
      <span className={styles.label}>{label}</span>
      {hasProgress && (
        <div className={styles.progressTrack} aria-hidden="true">
          <div
            className={styles.progressFill}
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
      )}
      {hint && <span className={styles.hint}>{hint}</span>}
    </div>
  );
}
